import { html } from 'lit';
const ArrowDownSmallPlus =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.207 8.793a1 1 0 0 0-1.414 0L11.5 13.086 7.207 8.793a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0 0-1.414" clip-rule="evenodd"/>
  </svg>
`;
export default ArrowDownSmallPlus;
